export default __webpack_public_path__ + "static/media/Maria Chicken and Salmon in grav.e9dc2500.png";